import { useLanguage } from '../context/LanguageContext';
import { Award, Globe } from 'lucide-react';

const TrustStats = () => {
  const { language } = useLanguage();

  const stats = language === 'he' ? [
    { icon: Award, value: 'MBA', label: 'פסיכולוגיה ארגונית', },
    { icon: Globe, value: '2', label: 'שפות - עברית ואנגלית', },
  ] : [
    { icon: Award, value: 'MBA', label: 'Organizational Psychology', },
    { icon: Globe, value: '2', label: 'Languages - HE & EN', },
  ];

  return (
    <section 
      className="py-12 md:py-16"
      style={{ backgroundColor: 'var(--charcoal)' }}
      data-testid="trust-stats"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 gap-8 md:gap-12 max-w-2xl mx-auto">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div 
                key={index} 
                className="text-center"
                data-testid={`trust-stat-${index}`}
              >
                <Icon 
                  size={24} 
                  className="mx-auto mb-3 opacity-60" 
                  style={{ color: 'var(--sage-400)' }}
                />
                <p 
                  className="text-3xl md:text-4xl font-medium mb-1"
                  style={{ fontFamily: 'Cormorant Garamond, serif', color: 'white' }}
                >
                  {stat.value}
                </p>
                <p className="text-sm text-gray-400">
                  {stat.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustStats;
